import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import ROUTES from './Routes.js';

function Navigation() {
  return (
    <div>
      <BrowserRouter>
        <Routes>
          {/********************************************************************* Home */}

          <Route path={ROUTES.layout.name} element={ROUTES.layout.component}>
            <Route
              path={ROUTES.index.name}
              element={ROUTES.index.component}
            ></Route>
            <Route
              path={ROUTES.about.name}
              element={ROUTES.about.component}
            ></Route>
            <Route
              path={ROUTES.contact.name}
              element={ROUTES.contact.component}
            ></Route>
            <Route
              path={ROUTES.career.name}
              element={ROUTES.career.component}
            ></Route>
            <Route
              path={ROUTES.services.name}
              element={ROUTES.services.component}
            ></Route>
            <Route
              path={ROUTES.gallery.name}
              element={ROUTES.gallery.component}
            ></Route>
            <Route
              path={ROUTES.register.name}
              element={ROUTES.register.component}
            ></Route>
            <Route
              path={ROUTES.login.name}
              element={ROUTES.login.component}
            ></Route>
            <Route
              path={ROUTES.applydispatcher.name}
              element={ROUTES.applydispatcher.component}
            ></Route>
            <Route
              path={ROUTES.planttree.name}
              element={ROUTES.planttree.component}
            ></Route>

          </Route>

          {/********************************************************************* Admin */}
          <Route
            path={ROUTES.adminlayout.name}
            element={ROUTES.adminlayout.component}
          >
            <Route
              path={ROUTES.adminhome.name}
              element={ROUTES.adminhome.component}
            ></Route>
            <Route
              path={ROUTES.contactlist.name}
              element={ROUTES.contactlist.component}
            ></Route>
            <Route
              path={ROUTES.contactdetail.name}
              element={ROUTES.contactdetail.component}
            ></Route>
            <Route
              path={ROUTES.CareerApplicationList.name}
              element={ROUTES.CareerApplicationList.component}
            ></Route>
            <Route
              path={ROUTES.careerdetail.name}
              element={ROUTES.careerdetail.component}
            ></Route>

          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}
export default Navigation;
